import * as React from "react";
import { UitkPrimaryButton } from "uitk-react-button";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { SavingsContentProps, SavingsInfo } from "../typings";
import { locKeys } from "../l10n";
import { TripAttachQualificationMipType } from "../TripAttachQualification";
import { useLocalization } from "@shared-ui/localization-context";

export const SavingsContent = (props: SavingsContentProps) => {
  const savingsInfo: SavingsInfo = {
    [TripAttachQualificationMipType.HOTMIP]: {
      action: locKeys.savingsHotelAction,
      message: locKeys.savingsHotel,
      rfrr: "SF_trip_CTA_HOTMIP",
    },
    [TripAttachQualificationMipType.CARMIP]: {
      action: locKeys.savingsCarAction,
      message: locKeys.savingsCar,
      rfrr: "SF_trip_CTA_CARMIP",
    },
  }[props.deepLinkMipType] || { action: "", message: "", rfrr: "" };

  const ButtonTracked = FlexClickTracker(UitkPrimaryButton);
  const shouldRenderActionButton = savingsInfo.action && savingsInfo.rfrr;
  const { formatText } = useLocalization();

  return (
    <>
      <h1 className="uitk-type-heading-500">{formatText(locKeys.savingsTitle)}</h1>
      <p className="uitk-type-paragraph-300">{formatText(savingsInfo.message, props.percentageOff)}</p>
      {shouldRenderActionButton && (
        <ButtonTracked
          className="all-t-margin-three"
          href={props.deepLink}
          moduleName={props.moduleName}
          linkName="RFRR Attach Savings Action Link"
          rfrr={savingsInfo.rfrr}
          text={formatText(savingsInfo.action)}
        />
      )}
    </>
  );
};
